import { HttpClient } from '@adapters/HttpClient';

export class StockErrorApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async unassignStock(
    orderId: number
  ): Promise<{ success: boolean; message: string }> {
    try {
      await this.httpClient.put(
        `/orders/${orderId}/solve-error/missing-stock`,
        {}
      );
      // Si la llamada es exitosa (no lanza error), devolvemos una respuesta de éxito personalizada
      return { success: true, message: 'Stock asignado correctamente' };
    } catch (error: any) {
      // Si hay un error, lo relanzamos para que sea manejado por el modal
      throw error;
    }
  }
}
